<script>
import Dropdown from "../Dropdown.vue";
import {LocationsStore} from "../../stores/LocationsStore";
import {mapStores, mapWritableState} from "pinia";
import {SessionCategoriesStore} from "../../stores/SessionCategoriesStore";
import {FormDataStore} from "../../stores/FormDataStore";

export default {
  name: "SetLocationQuestion",
  components: {Dropdown},
  computed: {
    ...mapStores(LocationsStore, SessionCategoriesStore),
    ...mapWritableState(FormDataStore, ["formData", "error"]),
  },
  data: function () {
    return {
      locations: [],
    };
  },
  methods: {
    async getSessionTypeLocations() {
      try {
        this.locations = await this.locationsStore.getLocationsBySessionCategory(this.formData.sessionCategory.sessionCategory);
      } catch (error) {
        this.error = true;
      }
    },
    setLocation(location) {
      this.formData.location.location = location;
    },
  },
  mounted() {
    this.formData.location.location = null;
    this.getSessionTypeLocations();
  }
}
</script>

<template>
  <div id="setSessionCategoryQuestion">
    <h2>Please select the site you wish to attend, or remote if you wish for this to be carried out on teams</h2>
    <div class="mb-4" v-if="locations.length > 0">
      <Dropdown :value="formData.location.location" :options="locations" :label="'name'" @change="setLocation" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-10 col-md-11">
          <ul class="location-address" v-if="formData.location.location !== null">
            <li class="ircc-blue" v-if="formData.location.location.address.lineOne">{{ formData.location.location.address.lineOne }}</li>
            <li class="ircc-blue" v-if="formData.location.location.address.lineTwo">{{ formData.location.location.address.lineTwo }}</li>
            <li class="ircc-blue" v-if="formData.location.location.address.lineThree">{{ formData.location.location.address.lineThree }}</li>
            <li class="ircc-blue" v-if="formData.location.location.address.lineFour">{{ formData.location.location.address.lineFour }}</li>
            <li class="ircc-blue" v-if="formData.location.location.address.postcode">{{ formData.location.location.address.postcode }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .location-address {
    margin-bottom: 30px;
    list-style: none;
    padding-left: 0;
    li {
      margin-bottom: 5px
    }
  }
</style>